import { Navigate } from "react-router-dom";
import userStore from "../store/stores/auth";

const PublicRoute = ({ children }) => {
  const auth = userStore((state) => state.auth);
  const profile = auth?.profile?.user;
  const access = profile?.resourceAccess;
  const showSalesAccess =
    access?.salesAccess?.toLowerCase() === 'true';
    const showDeliveryAccess = access?.deliveryRep?.toLowerCase() === 'true';


  if (auth.isAuthenticated && auth.token) {
    if (showSalesAccess || showDeliveryAccess) {
      return <Navigate to="/Orders/order/page/1" replace />;
    }
    else {
      return <Navigate to="/Patient%20Report/report/page/1" replace />;
    }
  }
  return children;
}

export default PublicRoute;
